module.exports = __webpack_public_path__ + "img/bg-strength-2.5022a531.jpg";